const mapStateToProps = state => 
    ({
        stepPortalWeb: state.solicitudEmpadronamientoPortalWeb.stepPortalWeb,
        datosPortalWeb: state.solicitudEmpadronamientoPortalWeb.datosPortalWeb,
        estaEmpadronado: state.solicitudEmpadronamiento.estaEmpadronado,
        estaFallecido: state.solicitudEmpadronamiento.estaFallecido,
        eventoRENAP: state.solicitudEmpadronamiento.eventoRENAP,
        catalogos: state.solicitudEmpadronamientoExtranjero.catalogos,
        estadoPadronDelCiudadanoEstaEmpadronado: state.solicitudEmpadronamientoExtranjero.estadoPadronDelCiudadanoEstaEmpadronado,
        residenciaPadron: state.solicitudEmpadronamientoPortalWeb.residenciaPadron,
    });
export default mapStateToProps;
